<template>
  <v-container fluid class="section-height">
    <v-row>
      <Header :value="'С какими темами ко мне чаще всего обращаются?'"/>
    </v-row>

    <v-row>
      <v-col
        :cols="$vuetify.breakpoint.smAndDown ? 12 : 4"
        v-for="(step, i) in steps"
        :key="i"
      >
        <ProblemCard
          :value="step"
          :index="i"
        />
      </v-col>
    </v-row>
    <v-row class="mb-10">
      <v-col cols="12" class="title font-weight-light text-center">
        Если вам нужна помощь психолога или есть вопросы – пишите, постараемся вместе найти пути решения вашей проблемы.
      </v-col>
      <v-col cols="12" class="title font-weight-light text-center">
        Можно записываться на консультацию ко мне, также я всегда могу порекомендовать коллег.
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Header from "@/components/Header";
import ProblemCard from "@/components/ProblemCard";

export default {
  name: "Requests",
  components: {
    Header,
    ProblemCard
  },
  data() {
    return {
      steps: [
        {
          title: 'Чувство потери смысла, апатия',
          text: 'Не знаю, ради чего я живу,ничего не хочу, жизнь потеряла краски, то, что раньше вызывало интерес, стало безразлично',
        },  // Не знаю, ради чего я живу,ничего не хочу, жизнь потеряла краски, то, что раньше вызывало интерес, стало безразлично
        {
          title: 'Жизненные кризисы, сложности с выстраиванием жизненной перспективы ',
          text: 'Не знаю, куда я двигаюсь, не понимаю, что мне нужно',
        },
        {
          title: 'Адаптация к переменам',
          text: 'Cмена работы, места жительства и т.д.',
        },
        {
          title: 'Трудности самоопределения',
          text: 'Кто Я в этом мире? Хочу разобраться в себе, в своих потребностях, мотивах, чувствах, ценностях',
        },
        {
          title: 'Тревога, страхи, чувство вины',
          // text: 'Не знаю, ради чего я живу',
        },
        {
          title: 'Неуверенность в себе, низкая самооценка',
          // text: 'Не знаю, ради чего я живу',
        },
        {
          title: 'Проблемы в отношениях с партнером',
          text: 'Частые ссоры, партнер меня не понимает/не слышит, кажется, что пропали чувства/ не понимаю, что я чувствую',
        },
        {
          title: 'Проблемы в отношениях с родителями',
          text: 'Трудности сепарации (хочу отделиться, начать жить своей жизнью, но не получается), проблемы взаимодействия между разными поколениями',
        },
        {
          title: 'Чувство одиночества, не удается выстроить близкие отношения',
        },
        {
          title: 'Постоянная самокритика, непринятие себя, в частности, недовольство своей внешностью/весом/телом',
          //text: 'Не знаю, ради чего я живу',
        },
        {
          title: 'Перфекционизм',
          text: 'Никогда не удается достичь совершенства, поэтому всегда собой недовольна; высокие ожидание и реальность не совпадают',
        },
        {
          title: 'Психосоматика',
          text: 'Беспокоят телесные симптомы, но врачи не находят их причину',
        },
      ],
    }
  }
}
</script>

<style scoped>

</style>
